export const GET_TEMPLATE = "GET_TEMPLATE";
export const FETCH_TEMPLATE = "FETCH_TEMPLATE";
export const PUBLISH_TEMPLATE = "PUBLISH_TEMPLATE";
export const SAVE_TEMPLATE = "SAVE_TEMPLATE";
export const UPDATE_CACHE_TEMPLATE = "UPDATE_CACHE_TEMPLATE";
